<template>

<table class="table table-sm">
  <thead>
    <tr>
      <th>#</th>
      <th>Type</th>
      <th>Name</th>
      <th>Score</th>
      <th>Sticker</th>
      <th>Size (rem, check the size on the canvas)</th>
    </tr>
  </thead>
  <tbody>
    <tr
      v-for="(zone, index) in zones"
      :key="zone.id"
      :class="{ 'table-primary': zone.id === selectedZoneId }"
      @click="$emit('select-zone', zone.id)"
    >
      <td>{{ index + 1 }}</td>
      <td>{{ zone.type }}</td>
      <td>
        <input
          class="form-control form-control-sm"
          v-model="zone.name"
          :placeholder="'(zone name)'"
          @click.stop
        />
      </td>
      <td>
        <input
          type="number"
          class="form-control form-control-sm scoreCol" 
          v-model.number="zone.score"
          @click.stop
        />
      </td>
      <td>
        <input
          type="text"
          maxlength="20"
          class="form-control form-control-sm text-center"
          v-model="zone.sticker"
          placeholder="🙂"
          @click.stop
        />
      </td>
      <td @click.stop>
        <div class="size-control">
          <input
            type="range"
            class="form-range form-range-sm"
            v-model.number="zone.stickerSize"
            min="0.5"
            max="2"
            step="0.1"
            @click.stop
          />
          <span class="size-value">{{ zone.stickerSize || 1 }}</span>
        </div>
      </td>
    </tr>
  </tbody>
</table>

  </template>
  
  <script setup>
  const props = defineProps({
    zones: Array,
    selectedZoneId: String,
    stickerZone: Object,
  })
  defineEmits(['select-zone'])

  console.log(props.stickerZone)
  </script>
  
  <style scoped>
  .table-primary {
    font-weight: bold;
  }

  .size-control {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 150px;
    border : 1px gainsboro solid;
    padding : 3px;
    border-radius: 5px;;
  }

  .form-range {
    flex: 1;
    cursor: pointer;
  }

  .size-value {
    font-size: 0.85rem;
    font-weight: 600;
    min-width: 30px;
    text-align: right;
    color: #495057;
  }

  .scoreCol{
    text-align: center;
    width : 80px;
  }
  </style>
  